module.exports = __webpack_public_path__ + "assets/img/bgvip.119bf3a7.png";